import * as Yup from 'yup';
import { createSortSchema, createPaginationSchema } from '@emfood/shared';

const ProductsListFilterSchema = Yup.object({
  productName: Yup.string().optional(),
  allergens: Yup.array().of(Yup.string().required()).optional(),
  categories: Yup.array().of(Yup.string().required()).optional(),
  certifications: Yup.array().of(Yup.string().required()).optional(),
  dietaryLifestyles: Yup.array().of(Yup.string().required()).optional(),
  countryOfOrigin: Yup.array().of(Yup.string().required()).optional(),
  distributorOrgId: Yup.string().optional(),
  distributorSiteId: Yup.string().optional(),
  isArchived: Yup.boolean().optional(),
});

export const ProductsListSearchParamsSchema = ProductsListFilterSchema.concat(
  createPaginationSchema()
).concat(
  createSortSchema(['name'] as const, {
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  })
);
